var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bulletin-read" },
    [
      _c(
        "a-button",
        {
          attrs: {
            type: "primary",
            loading: _vm.loading,
            disabled: _vm.reads.length > 0
          },
          on: { click: _vm.submitRead }
        },
        [
          _vm.reads.length === 0
            ? [_vm._v("\n      Elolvastam\n    ")]
            : [_vm._v("\n      Elolvasva\n    ")]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }